export default __webpack_public_path__ + "static/media/MadDJeann.facbb251.jpg";